/* eslint-disable getter-return */

import defaults from 'lodash/defaults';
import React from 'react';
import {createEventHandler} from 'recompose';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/throttleTime';
import {Observable} from 'rxjs/Observable';


const OPTIONS = {
  height: true,
  width: true,
  usePropsClassName: false,
  throttleTime: 1000 / 30,
};

// TODO: handle this globally somewhere?
let supportsPassive = false;
try {
  const opts = Object.defineProperty({}, 'passive', {
    get() {
      supportsPassive = true;
    },
  });
  window.addEventListener('test', null, opts);
} catch (e) { /* pass */
}

/**
 * @source https://stackoverflow.com/a/11744120/1800748
 * @return {number}
 */
function getWindowDimensions() {
  const w = window;
  const d = document;
  const e = d.documentElement;
  const g = document.body || d.getElementsByTagName('body')[0];
  // const y = w.innerHeight|| e.clientHeight|| g.clientHeight; // if we need height instead
  return {
    windowHeight: w.innerHeight || e.clientHeight || g.clientHeight,
    windowWidth: w.innerWidth || e.clientWidth || g.clientWidth,
  };
}

export const createDimensionObserver = (props$, o) => {
  const options = {};
  defaults(options, o || {}, OPTIONS);

  const {
    handler: setDivRef,
    stream: divRef$,
  } = createEventHandler();

  const windowAccessor = getWindowAccessor(options);
  const componentAccessor = getComponentAccessor(options);

  const windowDimensions$ = (supportsPassive
    ? Observable.fromEvent(window, 'resize', {passive: true})
    : Observable.fromEvent(window, 'resize'))
    .throttleTime(options.throttleTime, void 0, {leading: false, trailing: true})
    .map(() => getWindowDimensions())
    .startWith(getWindowDimensions())
    .takeUntil(props$.last())
    .distinctUntilChanged(null, windowAccessor);

  const componentDimensions$ = divRef$
    .startWith(null)
    .map(el => ({
      availableHeight: el ? el.offsetHeight : void 0,
      availableWidth: el ? el.offsetWidth : void 0,
    }))
    .distinctUntilChanged(null, componentAccessor);

  const dimensions$ = Observable
    .combineLatest(
      componentDimensions$,
      windowDimensions$,
      (componentDimensions, windowDimensions) => ({
        ...componentDimensions,
        ...windowDimensions,
      }))
    .takeUntil(props$.last());

  return {
    handler: setDivRef,
    stream: dimensions$,
  };
};

function getWindowAccessor(options) {
  if (options.height && options.width) {
    return compareWindowBoth;
  } else if (options.height) {
    return compareWindowHeight;
  } else {
    return compareWindowWidth;
  }
}

function getComponentAccessor(options) {
  if (options.height && options.width) {
    return compareComponentBoth;
  } else if (options.height) {
    return compareComponentHeight;
  } else {
    return compareComponentWidth;
  }
}

function compareWindowBoth({windowHeight, windowWidth}) {
  return `${windowHeight}|${windowWidth}`;
}

function compareWindowHeight({windowHeight}) {
  return windowHeight;
}

function compareWindowWidth({windowWidth}) {
  return windowWidth;
}

function compareComponentBoth({availableHeight, availableWidth}) {
  return `${availableHeight}|${availableWidth}`;
}

function compareComponentHeight({availableHeight}) {
  return availableHeight;
}

function compareComponentWidth({availableWidth}) {
  return availableWidth;
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-utils/ObserveDimensions.js